import Vue from 'vue'
import cs from 'vuetify/src/locale/cs'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  lang: {
    locales: { cs },
    current: 'cs'
  },
  icons: {
    iconfont: 'mdi'
  },
  theme: { disable: true }
})

export default {
  el: '#app',
  vuetify,
  data() {
    return {
      menuOpened: false
    }
  }
}
